<template>
	<a class="arrow-link" :href="href" @click="onClick">
		<Icon icon="triangle-right" color="red" :rotate="arrowDown ? 90 : 0"/> {{ text }}
	</a>
</template>

<script>
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Icon,
	},

	props: {
		text: {
			type: String,
			required: true,
		},
		href: {
			type: String,
			required: false,
			default: '#'
		},
		arrowDown: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	methods: {
		onClick (e)
		{
			if (!this.href || this.href === '#')
			{
				e.preventDefault();

				this.$emit('click');

				return;
			}

			return true;
		}
	},
}
</script>